import styles from './LayersGroup.module.css';
import { LayerToggleButton } from '../LayerToggleButton';
import { hasIdInArray } from '../../../utils/hasIdInArray';
import { connect } from 'react-redux';
import { onToggleLayer } from '../../../ac/onToggleLayer';
import Collapse from '@material-ui/core/Collapse';
import { useToggle } from '../../../hooks/useToggle';
import Icon from '@material-ui/core/Icon';
import classnames from 'classnames';
import { i18n } from '@lingui/core';

export const LayersGroupComponent = ({
    label,
    layers,
    displayedLayers,
    onToggleLayer,
    isLayersLoaded,
}) => {
    const [ show, setShow ] = useToggle(false);
    return (
        <div>
            <div
                onClick={setShow}
                className={classnames(styles.innerNavLabel, { [styles.innerNavLabelOpened]: show })}
            >
                {label}
                <Icon>expand_more</Icon>
            </div>
            <Collapse
                disableStrictModeCompat
                in={show}
            >
                <div className={styles.innerNavGrid}>
                    {
                        layers.map(({ id, label, additionalLayers }) => (
                            <LayerToggleButton
                                key={id}
                                isActive={hasIdInArray(displayedLayers, id)}
                                id={id}
                                onToggleLayer={onToggleLayer}
                                additionalLayers={additionalLayers}
                                isLayersLoaded={isLayersLoaded}
                            >
                                {i18n._(label)}
                            </LayerToggleButton>
                        ))
                    }
                </div>
            </Collapse>
        </div>
    );
};
const mapStateToProps = ({ displayedLayers, map: { isLayersLoaded } }) => ({ displayedLayers, isLayersLoaded });
export const LayersGroup = connect(mapStateToProps, { onToggleLayer })(LayersGroupComponent);
